import "./index.css";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { QueryClient, QueryClientProvider } from "react-query";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { TimeSpan } from "@/utility/time-span";
import { ConfigCatEnvProvider } from "@/components";
import { ConfigCatProvider, PollingMode } from "configcat-react";
import { ApiProvider } from "@/api/ApiProvider";

const queryClient: QueryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ConfigCatProvider
    sdkKey={process.env.CONFIG_CAT_SDK_KEY!}
    pollingMode={PollingMode.LazyLoad}
    options={{ cacheTimeToLiveSeconds: 60 * 60 * 12 }}
  >
    <ConfigCatEnvProvider>
      <QueryClientProvider client={queryClient}>
        <ApiProvider>
          {/* @Adem, future v7_startTransition is used to resolve console warning */}
          <RouterProvider
            router={router}
            future={{ v7_startTransition: true }}
          />
          <ToastContainer
            position="bottom-right"
            autoClose={
              process.env.MODE === "prod"
                ? TimeSpan.seconds.two
                : TimeSpan.seconds.five
            }
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick={true}
            closeButton={false}
            rtl={false}
            pauseOnFocusLoss={true}
            draggable={true}
            className={"custom-toast-container"}
            pauseOnHover={true}
            theme={"colored"}
          />
        </ApiProvider>
      </QueryClientProvider>
    </ConfigCatEnvProvider>
  </ConfigCatProvider>,
);